import React, { useMemo, useState } from 'react';
import Title from '../Title';
import HealthLogo from '~/assets/img/home/healthLogo.svg';
import HeaderBlueFlag from '~/assets/img/home/headerBlueFlag.svg';

import bannerConsortium from '~/assets/img/home/banner-consortium.png';
import bannerYellowFlag from '~/assets/img/home/bannerYellowFlag.png';

import OdontoPrice from '~/assets/img/home/odonto-price.png';
import SimulationPrice from '~/assets/img/home/simulation-price.png';
import SimulationPriceLoan from '~/assets/img/home/simulation-price-loan.png';
import UnemploymentPrice from '~/assets/img/home/unemployment-price.png';
import BagProtectionPrice from '~/assets/img/home/bag-protection-price.png';
import TakesCarePrice from '~/assets/img/home/takes-care-price.png';
import TakesCareCard from '~/assets/img/home/takes-care-card.png';
import TakesCareCardWeb from '~/assets/img/home/takes-care-card-web.png';
import DentalCard from '~/assets/img/home/dental-card.png';
import DentalCardWeb from '~/assets/img/home/dental-card-web.png';
import UnemploymentCard from '~/assets/img/home/unemployment-card.png';
import BagProtectionCard from '~/assets/img/home/bag-protection-card.png';
import AutoCard from '~/assets/img/home/auto-card.png';
import UnemploymentCardWeb from '~/assets/img/home/unemployment-card-web.png';
import BagProtectionCardWeb from '~/assets/img/home/bag-protection-card-web.png';
import AutoCardWeb from '~/assets/img/home/auto-card-web.png';
import PersonalLoanWeb from '~/assets/img/home/personal-loan-web.png';
import PersonalLoan from '~/assets/img/home/personal-loan.png';

import CareLogo from '~/assets/img/home/careLogo.svg';
import CreditLogo from '~/assets/img/home/creditLogo.svg';
import HeaderGreenFlag from '~/assets/img/home/headerGreenFlag.svg';
import HeaderYelloyFlag from '~/assets/img/home/headerYelloyFlag.svg';
import Header from './components/Header';
import Banner from '../Banner';
import { View } from 'react-native';
import useAppNavigation from '~/hooks/useAppNavigation';
import Container from '../Container';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { journeyLogUseCase } from '~/useCases/PSF/JourneyLogUseCase';
import { useUserInfoStore } from '~/stores/userInfo';
import PresentationBanner from '../PresentationBanner';
import Env from '~/env';

const AllServices: React.FC = () => {
  const { navigate } = useAppNavigation();
  const user = useUserInfoStore.getState().user;

  const [sectionWidth, setSectionWidth] = useState<number>(0);
  const columns = useMemo(() => (sectionWidth >= 608 ? 3 : 2), [sectionWidth]);
  const CREDIT_SERVICES = [
    !MarisaAppUtils.disableConsortium && {
      title: 'Marisa Consórcio',
      description: 'Realize os seus planos sem pagar juros e nem entrada',
      image: bannerConsortium,
      onPress: () => {
        if (user) {
          journeyLogUseCase(user, 'CONSORCIO');
        }

        MarisaAppUtils.goToConsortium();
      },
    },
  ];

  return (
    <Container>
      <Title
        title="Aproveite todos os nossos serviços
        feitos para você!"
      />

      <Header LeftLogo={<HealthLogo />} RightFlag={<HeaderBlueFlag />} />
      <View
        className="flex-row items-center mb-5"
        onLayout={(e) => setSectionWidth(e.nativeEvent.layout.width)}
      >
        <PresentationBanner
          image={{
            background: { mobile: DentalCard, web: DentalCardWeb },
            price: OdontoPrice,
          }}
          bannerWidth={sectionWidth / columns - 8}
          infos={{
            title: 'Plano Odonto',
            description: 'Complete o seu look com um sorriso radiante!',
          }}
          button={{
            label: 'CONHEÇA',
            onPress: () => {
              navigate('MarisaServicos_OdontoProtectionDetails');
            },
          }}
          className="mr-2"
        />

        <PresentationBanner
          image={{
            background: { mobile: TakesCareCard, web: TakesCareCardWeb },
            price: TakesCarePrice,
          }}
          bannerWidth={sectionWidth / columns - 8}
          infos={{
            title: 'Marisa Cuida',
            description:
              'Um serviço de consultas médicas, telemedicina ilimitadas 24h e mais',
          }}
          button={{
            label: MarisaAppUtils.disableInsurance
              ? 'CONHEÇA'
              : 'CONTRATE AQUI',
            onPress: () => {
              if (Env.MARISA_TAKES_CARE_LINK) {
                navigate('MarisaServicos_Iframe', {
                  url: Env.MARISA_TAKES_CARE_LINK,
                });
              } else {
                console.error('Marisa takes care link is not defined');
              }
            },
          }}
          className="mr-2"
        />
      </View>

      <View className="flex-row flex-wrap justify-between sm:justify-start sm:gap-4">
        {CREDIT_SERVICES.map((item, index) => {
          if (!item) {
            return null;
          }

          const shouldUseAllSpace =
            index === CREDIT_SERVICES.length - 1 &&
            CREDIT_SERVICES.length % 2 !== 0;

          return (
            <View
              key={index.toString()}
              className={
                shouldUseAllSpace ? 'flex-1' : 'w-[48%] my-4 sm:w-auto'
              }
            >
              <Banner
                title={item.title}
                description={item.description}
                buttonLabel="Conheça"
                topImage={bannerYellowFlag}
                image={item.image}
                onPressButton={item.onPress}
              />
            </View>
          );
        })}
      </View>

      <Header LeftLogo={<CareLogo />} RightFlag={<HeaderGreenFlag />} />

      <View className="flex-row items-center mb-5 flex-wrap sm:flex-nowrap">
        {MarisaAppUtils.disableInsurance ? (
          <></>
        ) : (
          <PresentationBanner
            image={{
              background: { mobile: AutoCard, web: AutoCardWeb },
              price: SimulationPrice,
            }}
            bannerWidth={sectionWidth / columns - 8}
            infos={{
              title: 'Seguro Auto',
              description: 'Aqui temos o seguro certo para o seu carro.',
            }}
            button={{
              label: 'CONTRATE AQUI',
              onPress: () => {
                navigate('MarisaServicos_MarisaAutoDetails');
              },
            }}
            className="mr-2 mb-3"
          />
        )}
        <PresentationBanner
          image={{
            background: { mobile: UnemploymentCard, web: UnemploymentCardWeb },
            price: UnemploymentPrice,
          }}
          bannerWidth={sectionWidth / columns - 8}
          infos={{
            title: 'Assistência desemprego',
            description: 'Segurança e tranquilidade pra você',
          }}
          button={{
            label: 'CONHEÇA',
            onPress: () => {
              navigate('MarisaServicos_UnemploymentAssistanceDetails');
            },
          }}
          className="mb-3 mr-2"
        />

        <PresentationBanner
          image={{
            background: {
              mobile: BagProtectionCard,
              web: BagProtectionCardWeb,
            },
            price: BagProtectionPrice,
          }}
          bannerWidth={sectionWidth / columns - 8}
          infos={{
            title: 'Proteção Bolsa',
            description: 'Proteja seu celular e seus pertences',
          }}
          button={{
            label: 'CONHEÇA',
            onPress: () => {
              // navigate('MarisaServicos_BagProtectionDetails');
              if (Env.BAG_PROTECTION_LINK) {
                navigate('MarisaServicos_Iframe', {
                  url: Env.BAG_PROTECTION_LINK,
                });
              } else {
                console.error('Bag protection link is not defined');
              }
            },
          }}
          className="mb-3"
        />
      </View>

      <Header LeftLogo={<CreditLogo />} RightFlag={<HeaderYelloyFlag />} />
      <View className="flex-row flex-wrap justify-between sm:justify-start sm:gap-4">
        <PresentationBanner
          image={{
            background: { mobile: PersonalLoan, web: PersonalLoanWeb },
            price: SimulationPriceLoan,
          }}
          bannerWidth={sectionWidth / columns - 8}
          infos={{
            title: 'Crédito Pessoal',
            description: 'Mais Possibilidades para seus planos',
          }}
          button={{
            label: 'CONHEÇA',
            onPress: () => {
              navigate('MarisaServicos_PersonalLoan');
            },
          }}
          className="mr-2 mb-3"
        />
      </View>
    </Container>
  );
};

export default AllServices;
